const initialstate = {
  fetching: null,
  fetchingPagination: null,
  fetchingSuccessful: null,
  fetchingFailed: null,
  error: null,
  errorText: null,
  practices: null,
  emptyList: null,
  lastTime: null,
};

const getPracticesReducer = (state = initialstate, action) => {
  switch (action.type) {
    case 'FETCHING_ALL_PRACTICES':
      return Object.assign({}, state, {
        fetching: true,
        fetchingPagination: false,
      });
    case 'FETCHING_ALL_PRACTICES_WITH_PAGINATION':
      return Object.assign({}, state, {
        fetching: false,
        fetchingPagination: true,
      });
    case 'FETCHING_ALL_PRACTICES_DONE':
      return Object.assign({}, state, {
        fetching: false,
        fetchingPagination: false,
        fetchingSuccessful: true,
        fetchingFailed: false,
        error: false,
        errorText: '',
        practices: action.payload.practices,
        lastTime: action.payload.lastTime
          ? action.payload.lastTime
          : state.lastTime,
        emptyList: false,
      });
    case 'ADD_PRACTICES_TO_ALL_PRACTICES':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: true,
        fetchingPagination: false,
        fetchingFailed: false,
        practices: Array.isArray(action.payload.practices)
          ? state.practices
            ? state.practices.concat(action.payload.practices)
            : action.payload.practices
          : state.practices,
        emptyList:
          Array.isArray(action.payload.practices) &&
          (action.payload.practices.length === 0 ||
            action.payload.practices.length % 10 > 0)
            ? true
            : false,
        lastTime: action.payload.lastTime
          ? action.payload.lastTime
          : state.lastTime,
        error: false,
        errorText: '',
      });
    case 'FETCHING_ALL_PRACTICES_FAILED':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: false,
        fetchingPagination: false,
        fetchingFailed: true,
        error: true,
        errorText: action.payload,
        practices: [],
        emptyList: false,
        lastTime: '',
      });

    case 'FETCHING_ALL_PRACTICES_PAGINATION_FAILED':
      return Object.assign({}, state, {
        fetchingPagination: false,
      });
    default:
      return state;
  }
};

export default getPracticesReducer;
